export const displayUpdatesToTeamMember = async (functionParameters={})=> {

    const {smetioPresentationClass, firstName, lastName, skillLevel, jobTitle, primaryLocationName } = functionParameters;
    const TXT = window.smetioTexts;

    const displayTeamMemberSubTitleAndParagraph = (await import(/* webpackPrefetch: true */ "@schaniag/private")).displayTeamMemberSubTitleAndParagraph;

    const {title, subTitle, paragraph} = displayTeamMemberSubTitleAndParagraph({firstName, lastName, jobTitle, skillLevel, primaryLocationName, TXT});
    
    smetioPresentationClass.updateTextAndImagesInDisplay({title, subTitle, paragraph});

};
